var request = require("./request");
var qs = require("../question-sets/qs.json");
var config = require("./config");
var resolve = require("./resolve");
var URL = require("url-parse");
var Promise = require("bluebird");
var guids = require("../utils/guids");
var shortGuids = require("../utils/shortGuids");

var shortGuid = null;
var callerReject = null;

var convertPropertyNamesToUppercase = function(obj) {
  var propertyNamesToDelete = [];
  var keys = Object.keys(obj);
  keys.sort();
  for (var j = 0; j < keys.length; j++) {
    var key = keys[j];
    if (obj.hasOwnProperty(key)) {
      var keyUpper = key.toUpperCase();
      if (!obj[keyUpper]) {
        obj[keyUpper] = obj[key];
        propertyNamesToDelete.push(key);
      }
    }
  }
  for (var i = 0; i < propertyNamesToDelete.length; i++) {
    var name = propertyNamesToDelete[i];
    delete obj[name];
  }
};

var postPaymentGatewayParams = function(
  cardholderName,
  applicationId,
  longGuid,
  shortGuid,
  expiry,
  lastFourDigitsOfCardNumber,
  cardholderAddress,
  cardholderPostcode,
  donationAmount
) {
  return request
    .post(resolve(config.url(), "/paymentgatewayparams"), {
      cardholderName: cardholderName,
      applicationId: applicationId,
      longGuid: longGuid,
      shortGuid: shortGuid,
      expiry: expiry,
      lastFourDigitsOfCardNumber: lastFourDigitsOfCardNumber,
      cardholderAddress: cardholderAddress,
      cardholderPostcode: cardholderPostcode,
      donationAmount: donationAmount,
      contributionAmount: 0
    })
    .promise();
};

var getPaymentGatewayParams = function(id) {
  return request
    .get(resolve(config.url(), "/paymentgatewayparams/" + id))
    .promise();
};

var createHiddenIframe = function() {
  var iframe = document.createElement("iframe");
  var uniqueString = Math.random()
    .toString(36)
    .substring(7);
  document.body.appendChild(iframe);
  iframe.style.display = "none";
  iframe.contentWindow.name = uniqueString;
  return iframe;
};

var rejectFunction = function(err) {
  callerReject({ err: err, shortGuid: shortGuid });
};
var crossDomainIframePost = function(actionUrl, params, resolve, reject) {
  var iframe = createHiddenIframe();
  iframe.onload = function() {
    var url = new URL(iframe.contentWindow.location.href, true);
    var alias = url.query.Alias;
    if (alias) {
      resolve(url.query.Alias);
      document.body.removeChild(iframe);
    } else {
      reject("Unable to retrieve alias from gateway");
    }
  };

  // construct a form with hidden inputs, targeting the iframe
  var form = document.createElement("form");
  form.target = iframe.contentWindow.name;
  form.action = actionUrl;
  form.method = "POST";

  // repeat for each parameter
  var keys = Object.keys(params);
  for (var j = 0; j < keys.length; j++) {
    var key = keys[j];
    if (params.hasOwnProperty(key)) {
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = params[key];
      form.appendChild(input);
    }
  }

  document.body.appendChild(form);
  form.submit();
};

var getAliasFromGateway = function(
  params,
  cardholderName,
  cardNumber,
  expiry,
  cvv
) {
  return new Promise(function(resolve, reject) {
    var aliasGatewayUrl = params.aliasGatewayUrl;
    delete params.aliasGatewayUrl;
    params.cardno = cardNumber;
    params.cn = cardholderName;
    params.cvc = cvv;
    params.ed = expiry;
    convertPropertyNamesToUppercase(params);
    delete params.COM;
    crossDomainIframePost(aliasGatewayUrl, params, resolve, reject);
  });
};

var postGatewayPayment = function(paymentRequest) {
  return request
    .post(resolve(config.url(), "/gatewaypayment"), paymentRequest)
    .promise();
};

var getGatewayPayment = function(id) {
  return request.get(resolve(config.url(), "/gatewaypayment/" + id)).promise();
};

var validate3dSecureWithServer = function(result, sign, orderId) {
  var url = resolve(config.url(), "/3dsecureresult/");
  return request
    .post(url, {
      result: result,
      sign: sign,
      orderId: orderId
    })
    .promise();
};

exports.Validate3dSecureResult = function(url, orderId) {
  return new Promise(function(resolve, reject) {
    var returnUrl = new URL(url, true);
    var result = returnUrl.query.result;
    var sign = returnUrl.query.sign;
    validate3dSecureWithServer(result, sign, orderId).then(function(response) {
      resolve({
        valid: true,
        result: result,
        response: response
      });
    });
  });
};

exports.ProcessPayment = function (
    applicationId,
    paymentCard,
    donation,
    billingAddress,
    billingPostcode,
    homeAddress,
    homePostcode,
    fundraiserId,
    browserInfo) {
    if (!homeAddress && !homePostcode) {
        homeAddress = billingAddress;
        homePostcode = billingPostcode;
    }

    var cardExpiry = String(paymentCard.expiryMonth) + String(paymentCard.expiryYear).slice(-2);
    var cardFourDigits = paymentCard.cardNumber.toString().substring(12);

    return new Promise(function (resolve, reject) {
        shortGuid = shortGuids.generate();
        callerReject = reject;
        var longGuid = shortGuids.decode(shortGuid);
        try {
            postPaymentGatewayParams(
                paymentCard.name,
                applicationId,
                longGuid,
                shortGuid,
                cardExpiry,
                cardFourDigits,
                billingAddress,
                billingPostcode,
                donation.donationAmount).then(function (paramsId) {
                    getPaymentGatewayParams(paramsId).then(function (params) {
                        getAliasFromGateway(params, paymentCard.name, paymentCard.cardNumber, cardExpiry, paymentCard.cvv).then(function (alias) {
                            var paymentRequest = {
                                orderId: params.ORDERID,
                                cardAlias: alias,
                                cvc: paymentCard.cvv,
                                donationAmount: donation.donationAmount,
                                address: billingAddress,
                                postcode: billingPostcode,
                                contributionAmount: 0,
                                useragent: navigator.userAgent,
                                applicationId: applicationId,
                                giftAid: donation.giftAid,
                                giftAidConfirm: donation.giftAidConfirm,
                                donorName: donation.donorName,
                                donorMessage: donation.donorMessage,
                                isAnonymous: donation.isAnonymous,
                                giftAidAddress: homeAddress,
                                giftAidPostcode: homePostcode,
                                fundraiserId: fundraiserId,
                                nameAlias: donation.donorAliasName,
                                email: donation.email,
                                donorType: donation.donorType,
                                termsAndConditions: donation.termsAndConditions,
                                companyName: donation.companyName,
                                isCompanyBenefit: donation.isCompanyBenefit,
                                companyBenefits: donation.companyBenefits,
                                paymentTypeBacs: donation.paymentTypeBacs,

                                browserColorDepth: browserInfo.browserColorDepth,
                                browserJavaEnabled: browserInfo.browserJavaEnabled,
                                browserLanguage: browserInfo.browserLanguage,
                                browserScreenHeight: browserInfo.browserScreenHeight,
                                browserScreenWidth: browserInfo.browserScreenWidth,
                                browserTimeZone: browserInfo.browserTimeZone,
                                browserUserAgent: browserInfo.browserUserAgent,
                                cardName: paymentCard.name,
                            };
                            postGatewayPayment(paymentRequest).then(function (postPaymentResult) {
                                getGatewayPayment(postPaymentResult).then(function (getGatewayResult) {
                                    resolve(getGatewayResult);
                                }, rejectFunction);
                            }, rejectFunction);
                        }, rejectFunction);
                    }, rejectFunction);
                }, rejectFunction);
        } catch (err) {
            rejectFunction(err, reject);
        }
    });
};
